module.exports = __webpack_public_path__ + "static/img/COMM.66bf7734.png";